var path = '/modules/contacts/views/pages/details/changelog.tpl.html';
var html = "<al-entity-change-log ng-if=\"vm.contact\" entity=\"'contact'\" entity-id=\"vm.contact.id\"></al-entity-change-log>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/contacts/views/pages/details/changelog.tpl.html
// module id = 2072
// module chunks = 1